
import {
  defineComponent,
  onActivated,
  onMounted,
  onUnmounted,
  reactive,
  toRefs,
} from "vue";
import { stateType } from "./operationLandType";
import { dateFormat } from "@/utils/util";
import {
  addFarmerLand,
  getFarmerLandData,
  updateFarmerLand,
} from "../../../../api/farmer";
import { Router, useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import { Toast } from "vant";
import events from "@/utils/events";
function statesData() {
  return {
    landArea: "",
    plantDate: "",
    plantModel: "",
    initDate: "",
    remark: "",
    sourceId: "",
    showPlantDialog: false,
    selectPlantDate: new Date(),
    minDate: new Date(1900, 1, 1),
    maxDate: new Date(2050, 1, 1),
    selectInitDate: new Date(),
    showInitDialog: false,
    typeId: "",
    landId: "",
    landInfo: {},
    plantId: "",
    isModel: false,
  };
}
export default defineComponent({
  setup() {
    const state = reactive<stateType>(statesData());
    const router = useRouter();
    const route = useRoute();
    onBeforeRouteLeave((to, from, next) => {
      if (to.name != "SelectModel") {
        Object.assign(state, statesData());
      } else if (to.name == "SelectModel" && state.landId) {
        // 编辑时选择model
        state.isModel = true;
      }
      next();
    });
    const { getLandInfo, onModelData } = useData(state);
    onMounted(() => {
      events.on("finished", onModelData);
    });
    onActivated(() => {
      state.typeId = route.query.typeId as string;
      state.landId = (route.query.landId as string) || "";
      state.sourceId = route.query.sourceId as string;
      if (state.landId) {
        getLandInfo();
      }
    });
    onUnmounted(() => {
      events.removeEvent("finished", onModelData);
    });

    return {
      router,
      ...toRefs(state),
      ...useEvent(state, router),
    };
  },
});

const useData = (state: stateType, router?: any) => {
  const onModelData = (e: any) => {
    state.plantId = e.id;
    state.plantModel = e.name;
  };
  const getLandInfo = async () => {
    const result: any = await getFarmerLandData(state.landId);
    if (result.data.code == 0) {
      const tempData = result.data.data;
      if (state.isModel) {
        state.plantModel = tempData.modelName;
        state.plantId = tempData.plantId;
      } else {
        state.plantModel = tempData.modelName;
        state.plantId = tempData.plantId;
        state.landInfo = tempData;
        state.landArea = tempData.area;
        state.plantDate = tempData.plantTime;
        state.initDate = tempData.initTime;
        state.remark = tempData.remark;
      }
    }
  };
  const addLand = async (params: any) => {
    const result: any = await addFarmerLand(params);
    if (result.data.code == 0) {
      Toast.success("已添加");
      const timer = setTimeout(() => {
        clearTimeout(timer);
        router.go(-1);
      }, 1000);
    }
  };
  const updateLand = async (params: any) => {
    const result: any = await updateFarmerLand(params);
    if (result.data.code == 0) {
      Toast.success("已修改");
      const timer = setTimeout(() => {
        clearTimeout(timer);
        router.go(-1);
      }, 1000);
    }
  };
  return {
    addLand,
    getLandInfo,
    updateLand,
    onModelData,
  };
};
const useEvent = (state: stateType, router: Router) => {
  const onConfirmInitDate = (e: any) => {
    const tempDate = dateFormat(e);
    state.initDate = tempDate.YYYY + "-" + tempDate.MM + "-" + tempDate.DD;
    state.showInitDialog = false;
  };
  const onConfirmPlantDate = (e: any) => {
    const tempDate = dateFormat(e);
    state.plantDate = tempDate.YYYY + "-" + tempDate.MM + "-" + tempDate.DD;
    state.showPlantDialog = false;
  };
  const onClickPlantModel = () => {
    router.push({
      path: "/baseManage/selectModel",
      query: {
        tempId: state.plantId,
        typeId: state.typeId,
      },
    });
  };
  const onClickPlantDate = () => {
    state.showPlantDialog = true;
  };
  const onClickInitDate = () => {
    state.showInitDialog = true;
  };
  const onSubmit = (value: any) => {
    const { addLand, updateLand } = useData(state, router);
    let param: any = {
      area: state.landArea,
      initTime: state.initDate,
      plantTime: state.plantDate,
      remark: state.remark,
      sourceId: state.sourceId,
      plantId: state.plantId,
    };
    if (state.landId) {
      param.id = state.landId;
      updateLand(param);
    } else {
      addLand(param);
    }
  };
  return {
    onClickPlantModel,
    onClickPlantDate,
    onClickInitDate,
    onConfirmPlantDate,
    onSubmit,
    onConfirmInitDate,
  };
};
